import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

import { BaseTreeItem, TreeItem } from '../event-details-common/event-details-common.models';
import { TreeItemComponent } from './tree-item.component';

@Component({
    selector: 'ms-nav-tree',
    templateUrl: 'tree.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TreeItemComponent],
})
export class TreeComponent {
    @Input() tree: BaseTreeItem;
    @Input() hideHeader = false;
    @Output() toggle = new EventEmitter<TreeItem>();
    @Output() toggleMarkets = new EventEmitter<TreeItem>();
    @Output() selectEvent = new EventEmitter<EventModel>();
    @HostBinding('class') className = 'nav-tree';

    get children(): TreeItem[] {
        return this.tree.children.filter((child) => !child.hidden);
    }

    trackByFn(index: any, item: BaseTreeItem | TreeItem): number {
        if ('id' in item) {
            return item.id;
        }

        return index;
    }

    onToggle(item: any): void {
        this.toggle.emit(item);
    }

    onToggleMarkets(item: TreeItem): void {
        this.toggleMarkets.emit(item);
    }

    onSelectEvent(event: EventModel): void {
        this.selectEvent.emit(event);
    }
}
